export default {"src":"/_next/static/media/logistics.36071266.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};